<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 46 46"
		width= "46" height="46"
	>
		<g stroke="#0074B5" fill="none" fill-rule="evenodd" stroke-linecap="square">
			<path d="M30.483 16 16 30.5M16 16l14.483 14.5" stroke-width="1.5"/>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
